import TreatmentTypeIds from 'constants/TreatmentTypeIds';
import {
  isExportAndLogsOrBreakBulk,
  isImportAndHeatTreatment,
  isContainerOrBreakBulkOrOther,
  isImportOrExportAndContainer,
  isExportOther,
} from 'util/JobTypeHelper';
import { isEthylFormate, isSulfurylFlouride } from 'util/TreatmentTypeHelper';
import moment from 'moment';

export const signoffWarnings = {
  fumigantNotPosted: {
    showWarning: showFumigantionNotPosted,
    message: `This job cannot be completed - Unposted, Insufficient Fumigant stock on hand.`,
  },
  appliedMBError:{
    showWarning:showTotalApplied,
    message: 'Total MB applied is not equal to total fumigant posted'
  },
  actualTemperature: {
    showWarning: showActualTemperatureWarning,
    message: `This job should not be signed off - Minimum temperature has not been met`,
  },
  treatmentPeriod: {
    showWarning: showTreatmentPeriodWarning,
    message: `This job should not be signed off - Treatment period has not been met`,
  },
  treatmentResultNotPassed: {
    showWarning: showTreatmentResultNotPassedWarning,
    message: `This job should not be signed off - Record has not passed`,
  },
  treatmentRecaptureNotEntered: {
    showWarning: showRecaptureMissing,
    message: `This job should not be signed off - Recapture data missing`,
  },
  treatmentMissingReadingTimes: {
    showWarning: showMissingReadingTimes,
    message: 'This job should not be signed off - Readings are missing',
  },
  treatmentMissingContainerNumbers:{
     showWarning: showNoContainerNumbers,
    message: 'This job should not be signed off - Container Numbers are missing',
  }
};

function showTotalApplied({
    treatmentResults,
  treatmentResultRecords,
}){
  let isError = true;
    if (treatmentResultRecords) {
    var cri = treatmentResultRecords.map(item =>item.concentrationReadingItem)
    var mbkgList = treatmentResultRecords.map(item=>item.mbkg);
     var mbAppliedList = treatmentResultRecords.map(item=>item.mbDoseApplied);
      var mbkgTotal = mbkgList.flat().reduce((total,item) =>total + (item>0.1?item :0 ||0),0);
      var appliedTotal = mbAppliedList.flat().reduce((total,item) =>total + (item ||0),0);
    var topupdoseTotal = cri.flat().reduce((total,item) => total +(item.topupDose || 0),0);
    var topupandapplied = appliedTotal + topupdoseTotal;
   
    console.log('topupdoseTotal',topupdoseTotal)
        console.log('appliedTotal',appliedTotal)
            console.log('mbkgTotal',mbkgTotal)

      if(mbkgTotal === topupandapplied ){
     console.log('crihere',cri)
     isError = false;
      }
    }

    return isError;

}



function showFumigantionNotPosted({
  treatmentResults,
  treatmentResultRecords,
}) {
  // if(treatmentResultRecords.mbJson != undefined && treatmentResultRecords.mbJson !=''){
  //var jsonString = treatmentResultRecords.map(x=>x.mbJson);
  //var mbBottlesList = treatmentResultRecords.map(y=>y.mbBottles)

  let hasFalse = false;
  if (treatmentResults) {
    const hasFumigant = treatmentResults.fumigantDetails;

    if (hasFumigant != undefined && hasFumigant.length > 0) {
      const hasFalseFumigants = hasFumigant.filter(
        (x) => x.eralisUpdated === false,
      );
      return (hasFalse = hasFumigant.some((x) => x.eralisUpdated === false));
    }
  }
  if (treatmentResultRecords) {
    const hasmbBottles = treatmentResultRecords.map((x) => x.mbBottles);
    const hasFumigant = treatmentResultRecords.flatMap(
      (y) => y.fumigantDetails,
    );

    if (hasFumigant != undefined && hasFumigant[0] != undefined) {
      const hasFalseFumigants = hasFumigant.filter(
        (x) => x.eralisUpdated === false,
      );
      return (hasFalse = hasFumigant.some((y) => y.eralisUpdated === false));
    }
    if (hasmbBottles != undefined && hasmbBottles[0] != undefined) {
      hasFalse = treatmentResultRecords.some((record) => {
        const items = JSON.parse(record.mbJson);
        return items.some((item) => item.EralisUpdated === false);
      });
    }
  }
  return hasFalse;
}

function showActualTemperatureWarning({
  treatmentResults,
  treatmentDetails,
  treatmentResultRecords,
  type,
}) {
  if (!treatmentDetails || !treatmentDetails.mandatoryMinimumTemperature)
    return false;
  const treatmentTypeAllowed = isTreatmentTypeAllowed(
    treatmentDetails.treatmentTypeId,
  );
  if (!treatmentTypeAllowed) return false;
  return isExportAndLogsOrBreakBulk(type) || type.name === 'MB Logs In Hold'
    ? areAnyTreatmentResultRecordsTemeratureInvalid(
        treatmentResultRecords,
        treatmentDetails.mandatoryMinimumTemperature,
      )
    : treatmentResults != null &&
        treatmentResults !== undefined &&
        treatmentResults.actualTemperature &&
        treatmentResults.actualTemperature <
          treatmentDetails.mandatoryMinimumTemperature;
}
function showRecaptureMissing({ treatmentResultRecords }) {
  return areAnyTreatmentResultRecordsRecaptureInvalid(treatmentResultRecords);
}
function showMissingReadingTimes(treatmentResultRecords) {
  return isEthylFormate(treatmentResultRecords.treatmentDetails.treatmentTypeId)
    ? isMissingReadingTimes(treatmentResultRecords)
    : false;
}

function showTreatmentPeriodWarning({
  treatmentDetails,
  treatmentResults,
  treatmentResultRecords,
  type,
}) {
  const treatmentTypeAllowed = isTreatmentTypeAllowed(
    treatmentDetails.treatmentTypeId,
  );
  if (!treatmentTypeAllowed || isExportOther(type)) return false;
  return isExportAndLogsOrBreakBulk(type) ||
    type.name === 'MB Logs In Hold' ||
    isImportOrExportAndContainer(type) ||
    isContainerOrBreakBulkOrOther(type)
    ? areAnyTreatmentResultRecordsDatesInvalid(
        treatmentResultRecords,
        treatmentDetails.treatmentPeriod,
      )
    : isImportAndHeatTreatment(type)
    ? areTreatmentResultsDatesInvalidMinutes(
        treatmentResults,
        treatmentDetails.treatmentPeriod,
      )
    : areTreatmentResultsDatesInvalid(
        treatmentResults,
        treatmentDetails.treatmentPeriod,
      );
}

function showTreatmentResultNotPassedWarning({ treatmentResultRecords }) {
  return treatmentResultRecords.some(
    (treatmentResult) =>  treatmentResult.passed != null && !treatmentResult.passed,
  );
}

function showNoContainerNumbers({treatmentResultRecords,type}){
 if( isImportOrExportAndContainer(type)){
  return treatmentResultRecords.some((trr)=>trr.containerNumber == undefined || trr.containerNumber == null )
  }
}

//function showTreatmentRecaptureResultNotPassedWarning({treatmentResultRecords})

function isTreatmentTypeAllowed(treatmentTypeId) {
  const treatmentTypesToQuery = [
    TreatmentTypeIds.MethylBromide,
    TreatmentTypeIds.Pestigas,
    TreatmentTypeIds.ThermoFog,
    TreatmentTypeIds.Heat,
    TreatmentTypeIds.HydrogenCyanide,
    TreatmentTypeIds.AlphosNonVessel,
    TreatmentTypeIds.AlPhosVessel,
    treatmentTypeId.VaporPhos,
    treatmentTypeId.EthylFormate,
    treatmentTypeId.SulfurylFlouride,
  ];
  return treatmentTypesToQuery.includes(treatmentTypeId);
}

function areTreatmentResultsDatesInvalid(treatmentResults, treatmentPeriod) {
  return isInvalidTreatmentPeriod(
    treatmentResults.startDate,
    treatmentResults.endDate,
    treatmentPeriod,
  );
}

function areAnyTreatmentResultRecordsTemeratureInvalid(
  treatmentResultRecords,
  mandatoryMinimumTemperature,
) {
  return treatmentResultRecords.some(
    (treatmentResult) =>
      treatmentResult.actualTemperature &&
      treatmentResult.actualTemperature < mandatoryMinimumTemperature,
  );
}
function areAnyTreatmentResultRecordsRecaptureInvalid(treatmentResultRecords) {
  return treatmentResultRecords.some(
    (treatmentResult) =>
      treatmentResult.recaptureReadingItem.length == 0 &&
      treatmentResult.efConcentrationReadingItem == undefined,
  );
}

function isMissingReadingTimes(treatmentResultRecords) {
  let hasReadings =
    treatmentResultRecords.treatmentResultRecords.length > 0
      ? treatmentResultRecords.treatmentResultRecords[0].efConcentrationReadingItem.some(
          ({ phase }) => phase == 2,
        ) &&
        treatmentResultRecords.treatmentResultRecords[0].efConcentrationReadingItem.some(
          ({ phase }) => phase == 0,
        )
      : false;
  return !hasReadings;
}

function areAnyTreatmentResultRecordsDatesInvalid(
  treatmentResultRecords,
  treatmentPeriod,
) {
  return treatmentResultRecords.some((treatmentResult) =>
    isInvalidTreatmentPeriod(
      treatmentResult.startDate,
      treatmentResult.endDate,
      treatmentPeriod,
    ),
  );
}

function areTreatmentResultsDatesInvalidMinutes(
  treatmentResults,
  treatmentPeriod,
) {
  /* return isInvalidTreatmentPeriodMinutes(
    treatmentResults.startDate,
    treatmentResults.endDate,
    treatmentPeriod,
  );*/
  return false;
}

function isInvalidTreatmentPeriod(startDate, endDate, treatmentPeriod) {
  const start = moment(startDate);
  const end = moment(endDate);
  let duration = moment.duration(end.diff(start));
  let calculatedTreatmentPeriod = duration.asHours();
  return calculatedTreatmentPeriod < treatmentPeriod;
}

function isInvalidTreatmentPeriodMinutes(startDate, endDate, treatmentPeriod) {
  /*const start = moment(startDate);
  const end = moment(endDate);
  let duration = moment.duration(end.diff(start));
  let calculatedTreatmentPeriod =
    parseInt(duration.asHours(), 10) * 60 + duration.minutes();
  return calculatedTreatmentPeriod < treatmentPeriod;*/
  return false;
}

export const jobCertificationWarnings = {
  stopCredit: {
    showWarning: showStopCreditWarning,
    message: `The Treatment Certificate cannot be issued because Stop Credit is ticked`,
  },
  doNotCertify: {
    showWarning: showDoNotCertifyWarning,
    message: `The Treatment Certificate cannot be issued because Do Not Certify is ticked`,
  },
  inactive: {
    showWarning: showInactiveWarning,
    message: `The Treatment Certificate cannot be issued because client is inactive`,
  },
};

function showStopCreditWarning({ stopCredit }) {
  return stopCredit;
}

function showDoNotCertifyWarning({ doNotCertify }) {
  return doNotCertify;
}
function showInactiveWarning({ inactive }) {
  return inactive;
}
